// src/redux/slices/themeSlice.js
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ThemePreference = "light" | "dark" | "system";

const prevLocalTheme = localStorage.getItem("tradegpt-darkmode");
const savedPref = (localStorage.getItem("tradegpt-theme")) as ThemePreference
  ?? (prevLocalTheme ? (prevLocalTheme === "true" ? "dark" : "light") : "system");

if (prevLocalTheme !== null) {
  localStorage.setItem("tradegpt-theme", savedPref);
  localStorage.removeItem("tradegpt-darkmode");
}
const getSystemDarkMode = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const initialState = {
  darkMode: savedPref === "system"
    ? getSystemDarkMode()
    : savedPref === "dark",
  localTheme: savedPref,
};
const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
    },
    updateLocalTheme: (state, action: PayloadAction<ThemePreference>) => {
      const pref = action.payload;
      state.localTheme = pref;
      if (pref === "system") {
        state.darkMode = getSystemDarkMode();
      }
      else {
        state.darkMode = pref === "dark";
      }
      localStorage.setItem("tradegpt-theme", pref);
    },
  },
});

export const { toggleDarkMode, updateLocalTheme } = themeSlice.actions;
export default themeSlice.reducer;
